import PropTypes from 'prop-types';
import React from 'react';

class SilentErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  render() {
    const { hasError } = this.state;
    const { children } = this.props;
    if (hasError) return null;
    return children;
  }
}

SilentErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
};

export default SilentErrorBoundary;
